import * as React from "react";
import { useNavigatorOnLine } from "../../hooks/useNavigatorOnLine";
import { Toast } from "../../components/notify/Notify";

export const NetworkStatusIndicator = () => {
  const isOnline = useNavigatorOnLine();
  const firstUpdate = React.useRef(true);

  React.useLayoutEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    isOnline
      ? Toast("info", "you are online")
      : Toast("warning", "You are currently offline");
  }, [isOnline]);

  return null;
};
